import eygpt from "../../assets/flags/cairo-flagpole-egypt-new-administrative-capital-aerial.png";
import jeddah from "../../assets/flags/jedda-flagpole.jpeg";
import Lshap from "../../assets/flagpoles/l-shape-flagpoles-landscape.png";
import printer from "../../assets/stickers/printer.jpeg";
import delivery from "../../assets/other/delivery-box.jpeg";

export type OurWorkItem = {
  id: string;
  cat: "records" | "events";
  titleKey: string;
  blurbKey: string;
  locationKey: string;
  year?: number;
  metrics: Array<{ labelKey: string; value: string }>;
  image?: string | null;
  descriptionKey?: string;
  faq?: Array<{ qKey: string; aKey: string }>;
};

export const ourworkKeys = {
  pageTitle: "ourwork:title",
  pageSubtitle: "ourwork:subtitle",

  filters: {
    all: "ourwork:filters:all",
    records: "ourwork:filters:records",
    government: "ourwork:filters:government",
    events: "ourwork:filters:events",
  },

  labels: {
    year: "ourwork:labels:year",
    location: "ourwork:labels:location",
  },
} as const;

export const ourworks: OurWorkItem[] = [
  // ── 1. Cairo Flagpole — current world's tallest (2021–present) ──────────────
  {
    id: "cairo-flagpole-flag",
    cat: "records",
    titleKey: "ourwork:items:cairoFlag:title",
    blurbKey: "ourwork:items:cairoFlag:blurb",
    locationKey: "ourwork:items:cairoFlag:location",
    year: 2021,
    metrics: [
      { labelKey: "ourwork:labels:size", value: "60 × 40 m" },
      { labelKey: "ourwork:labels:area", value: "2,400 m²" },
      { labelKey: "ourwork:labels:poleHeight", value: "201 m" },
      { labelKey: "ourwork:labels:rank", value: "#1 World's Tallest (2021–)" },
    ],
    image: eygpt,
    faq: [
      {
        qKey: "ourwork:items:cairoFlag:faq:q1",
        aKey: "ourwork:items:cairoFlag:faq:a1",
      },
      {
        qKey: "ourwork:items:cairoFlag:faq:q2",
        aKey: "ourwork:items:cairoFlag:faq:a2",
      },
    ],
  },

  // ── 2. Jeddah Flagpole — world's tallest 2014–2021 ──────────────────────────
  {
    id: "jeddah-flagpole-flag",
    cat: "records",
    titleKey: "ourwork:items:jeddahFlag:title",
    blurbKey: "ourwork:items:jeddahFlag:blurb",
    locationKey: "ourwork:items:jeddahFlag:location",
    year: 2014,
    metrics: [
      { labelKey: "ourwork:labels:size", value: "49.5 × 33 m" },
      { labelKey: "ourwork:labels:area", value: "1,633 m²" },
      { labelKey: "ourwork:labels:poleHeight", value: "171 m" },
      {
        labelKey: "ourwork:labels:rank",
        value: "#1 World's Tallest (2014–2021)",
      },
    ],
    image: jeddah,
    faq: [
      {
        qKey: "ourwork:items:jeddahFlag:faq:q1",
        aKey: "ourwork:items:jeddahFlag:faq:a1",
      },
      {
        qKey: "ourwork:items:jeddahFlag:faq:q2",
        aKey: "ourwork:items:jeddahFlag:faq:a2",
      },
    ],
  },

  // ── 3. Highway Flag Campaign — corrected to 3,600 flags / 84 km / 3 days ───
  {
    id: "highway-flag-campaign",
    cat: "events",
    titleKey: "ourwork:items:highwayCampaign:title",
    blurbKey: "ourwork:items:highwayCampaign:blurb",
    locationKey: "ourwork:items:highwayCampaign:location",
    year: 2022,
    metrics: [
      { labelKey: "ourwork:labels:flagsMade", value: "3,600" },
      { labelKey: "ourwork:labels:span", value: "84 km" },
      { labelKey: "ourwork:labels:turnaround", value: "3 days" },
      { labelKey: "ourwork:labels:poleType", value: "L-Shape" },
    ],
    image: Lshap,
  },

  // ── 4. High-Speed Fabric Printing ───────────────────────────────────────────
  {
    id: "high-speed-printing",
    cat: "records",
    titleKey: "ourwork:items:highSpeedPrinting:title",
    blurbKey: "ourwork:items:highSpeedPrinting:blurb",
    locationKey: "ourwork:items:highSpeedPrinting:location",
    metrics: [
      { labelKey: "ourwork:labels:speed", value: "600–700 m/hour" },
      {
        labelKey: "ourwork:labels:technology",
        value: "Industrial Dye-Sublimation",
      },
      { labelKey: "ourwork:labels:turnaround", value: "Continuous production" },
    ],
    image: printer,
  },

  // ── 5. 24-Hour Order Fulfilment ──────────────────────────────────────────────
  {
    id: "24hr-order-fulfilment",
    cat: "records",
    titleKey: "ourwork:items:fastFulfilment:title",
    blurbKey: "ourwork:items:fastFulfilment:blurb",
    locationKey: "ourwork:items:fastFulfilment:location",
    metrics: [
      { labelKey: "ourwork:labels:turnaround", value: "24 Hours" },

      { labelKey: "ourwork:labels:coverage", value: "UAE & International" },
    ],
    image: delivery,
    faq: [
      {
        qKey: "ourwork:items:fastFulfilment:faq:q1",
        aKey: "ourwork:items:fastFulfilment:faq:a1",
      },
      {
        qKey: "ourwork:items:fastFulfilment:faq:q2",
        aKey: "ourwork:items:fastFulfilment:faq:a2",
      },
    ],
  },
];
